import CatalogSkeleton from 'components/CatalogSkeleton'
import VideoList from 'components/VideoList'
import ContainerAuthenticated from 'containers/Authenticated'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useI18n from 'hooks/useI18n'
import { apiRequest, exposeStrapiError } from 'utils'
import { ReadContent } from 'services/shareLink'


export default function SubCategoryShare() {

  const { token } = useParams()
  const { t } = useI18n()
  const [register, setRegister] = useState([])
  const [loading, setLoading] = useState(false)
  const [renderOption, setRenderOption] = useState('gallery')


  const handleContent = useCallback(async () => {
    setLoading(true)
    const results = await apiRequest(() => ReadContent(token))
    if (!exposeStrapiError(results)) {
      setRegister(results)
    }
    setLoading(false)
  }, [token])
  useEffect(() => {
    handleContent()
  }, [handleContent]);

  return (
    <ContainerAuthenticated keep headerSecondary share>
      {
        (loading) ? <CatalogSkeleton /> :
          <>
            <VideoList
              enablePdfPreview
              listOption
              setRenderOption={setRenderOption}
              renderOption={renderOption}
              data={register}
              wide
              label={t('filters')}
              nobutton
              noShare
            />
            {/* {pageCount === 1 ?
              null : <CustomTablePagination count={total} page={page} rowsPerPage={pageSize} onPageChange={onPageChange} />} */}
          </>
      }
    </ContainerAuthenticated>
  )
}
